export default "__VITE_ASSET__DfGd0cnb__"